import React, { useEffect } from 'react';
import { wire } from 'react-hot-wire';

import ErrorLayer from './ErrorLayer';

export const InvalidTokenError = props => {
	const accessTokenService = props['services.accessTokenService'];
	const navigationService = props['services.navigationService'];
	const returnUrlService = props['services.returnUrlService'];

	useEffect(() => {
		accessTokenService.clear();
		navigationService.load(returnUrlService.loginUrl(window.location));
	}, []);

	return <ErrorLayer {...props} />;
};

export default wire(
	['services.accessTokenService', 'services.navigationService', 'services.returnUrlService'],
	InvalidTokenError
);
